import React from 'react';
import styled from 'styled-components';
import { BreadcrumbItem } from './type';
import { useHistory } from "react-router-dom";
import { redirectToOld } from '__utils/common-utils';

const BreadcrumbCont = styled.div`
    font-size: 14px;
    color: #757575;
    margin-bottom: 24px;
    .clickable {
        cursor: pointer;
        &:hover{
            color: #236df1;
        }
    }
    .current{
        color: black;
    }
`;

interface BreadcrumbProps {
    list: BreadcrumbItem[]
}

const Breadcrumb: React.FC<BreadcrumbProps> = (props: BreadcrumbProps) => {

    const history = useHistory();

    const onBreadcrumbClick = (selBreadCrumb: BreadcrumbItem) => {
        if (selBreadCrumb.isExternal)
        {
            redirectToOld(selBreadCrumb.url);
        } else
        {
            history.push(selBreadCrumb.url);
        }
    }

    return (<BreadcrumbCont>
        {
            props.list.map((item: BreadcrumbItem, index: number) => {
                if (index < props.list?.length - 1)
                {
                    return <span key={ index } className="clickable" onClick={ () => onBreadcrumbClick(item) }>{ item.text } &gt; </span>;
                } else
                {
                    return <span className="current" key={ index }>{ item.text }</span>;
                }
            })
        }
    </BreadcrumbCont>)
}

export default Breadcrumb;